// extracted by mini-css-extract-plugin
export var active = "index-module--active--59Ust";
export var personImageContainer = "index-module--personImageContainer--dSKWn";
export var speerpuntButton = "index-module--speerpuntButton--SRF2c";
export var partyBlock = "index-module--partyBlock--2ew9k";
export var partyLogo = "index-module--partyLogo--QG9+y";
export var partyTitle = "index-module--partyTitle--zAfpO";
export var partyStip = "index-module--partyStip--zvW7t";
export var partyContent = "index-module--partyContent--DH9Ne";